import React, { useRef, useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { IoIosAdd } from "react-icons/io";
//import Loading from '../views/Loading';
import ProcedureForm from "../components/ProcedureForm";
import ShowCases from "./ShowCases";

function ProcedureTypes({
  openGroPlan,
  setOpenGroPlan,
  getTreatmentPlans,
  showArrows,
  setShowArrows,
  setReady,
}) {
  const ref = useRef();
  //const [message,setMessage] = useState('')
  //const [ready, setReady] = useState(false);
  const [slidesToShow, setSlidesToShow] = useState(3);
  const [procedurePdf, setProcedurePdf] = useState({
    isOpen: false,
    data: null,
  });
  const [procedureTypes, setProcedureTypes] = useState(null);
  const [newList, setNewList] = useState(procedureTypes);
  const [procedureForm, setProcedureForm] = useState(false);

  const [adminProcedures, setAdminProcedures] = useState(null);
  const [matchProcedure, setMatchProcedure] = useState(null);

  const [gender, setGender] = useState("All");
  const [age, setAge] = useState("All");

  const [openCases, setOpenCases] = useState(false);

  let settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    arrows: false,
    variableWidth: true,
  };

  useEffect(() => {
    let min = 0;
    let max = 200;
      if (age === "All") {
        min = 0;
        max = 200;
      }else if (age === "under 20") {
        min = 0;
        max= 20;
      } else if (age === "over 70") {
        min = 71;
        max = 200
      } else {
        min = age.split("-")[0];
        max = age.split("-")[1];
      }
      
      setReady(false);
      fetch(
        `${process.env.REACT_APP_API}/clinic/templates?gender=${
          gender === "Male" ? "M" : gender === "Female" ? "F" : gender
        }&min_age=${min}&max_age=${max}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      )
        .then((response) => response.json())
        .then((response) => {
          if (response.success) {
            setProcedureTypes(response.treatment_procedures);
            setNewList(response.treatment_procedures);
            setAdminProcedures(response.procedures);
          }
        })
        .catch((error) => {
          console.error(error);
          //setMessage('Some Error Occured. Please Try Again Later');
        })
        .finally(() => {
          setReady(true);
        });
  }, [gender, age]);

  const removeItem = (obj) => {
    if (showArrows) {
      setShowArrows(!showArrows);
    }
    //setShowArrows(!showArrows);

    if (openCases) {
      setOpenCases(!openCases);
      setProcedurePdf({ isOpen: true, data: obj });
      return;
    }
    if (procedureForm) {
      setProcedureForm(!procedureForm);
      setProcedurePdf({ isOpen: true, data: obj });
      return;
    }
    if (
      newList.length === 1 &&
      newList.map((item) => item.title === obj.title)
    ) {
      setNewList(procedureTypes);
      setProcedurePdf({ isOpen: false, data: null });
      setSlidesToShow(3);
      setShowArrows(!showArrows);
    } else {
      let newProcedureTypes = procedureTypes.filter(
        (item) => item.title === obj.title
      );
      setNewList(newProcedureTypes);
      setProcedurePdf({ isOpen: true, data: obj });
      setSlidesToShow(1);
    }
  };
  const openProcedure = (obj) => {
    if (showArrows) {
      setShowArrows(!showArrows);
    }
    //setShowArrows(!showArrows);
    if (openCases) {
      setOpenCases(!openCases);
      setProcedureForm(!procedureForm);
      return;
    }
    if (procedurePdf.isOpen) {
      setProcedurePdf({ isOpen: false, data: null });
      setProcedureForm(!procedureForm);
      return;
    }
    if (
      newList.length === 1 &&
      newList.map((item) => item.title === obj.title)
    ) {
      setNewList(procedureTypes);
      setProcedureForm(!procedureForm);
      setSlidesToShow(3);
      setShowArrows(!showArrows);
    } else {
      let newProcedureTypes = procedureTypes.filter(
        (item) => item.title === obj.title
      );
      setNewList(newProcedureTypes);
      setProcedureForm(!procedureForm);
      setSlidesToShow(1);
    }

    const procedure = adminProcedures.filter((item) => item.name === obj.title);
    setMatchProcedure(procedure[0]);
  };

  const cases = (obj) => {
    if (showArrows) {
      setShowArrows(!showArrows);
    }
    if (procedureForm) {
      setProcedureForm(!setProcedureForm);
      setOpenCases(!openCases);
      return;
    }
    if (procedurePdf.isOpen) {
      setProcedurePdf({ isOpen: false, data: null });
      setOpenCases(!openCases);
      return;
    }
    if (
      newList.length === 1 &&
      newList.map((item) => item.title === obj.title)
    ) {
      setNewList(procedureTypes);
      setOpenCases(!openCases);
      setSlidesToShow(3);
      setShowArrows(!showArrows);
    } else {
      let newProcedureTypes = procedureTypes.filter(
        (item) => item.title === obj.title
      );
      setNewList(newProcedureTypes);
      setOpenCases(!openCases);
      setSlidesToShow(1);
    }
  };

  return (
    <>
      {/* <Loading message={"Loading Today's Treatment Plan"} ready={ready} /> */}

      <div style={{ width: "90%", margin: "0 auto" }}>
        <Slider ref={ref} {...settings}>
          {newList &&
            newList.map((item) => {
              return (
                <>
                  <div
                    style={{
                      margin: "0 2.4rem",
                      width: "16rem",
                      padding: "2rem 0",
                    }}
                  >
                    <div
                      style={{
                        textAlign: "center",
                        backgroundColor: "rgba(255, 255, 255, 0.9)",
                        padding: "1rem 1rem",
                        color: "black",
                        position: "relative",
                      }}
                    >
                      <div
                        style={{
                          width: "3rem",
                          height: "3rem",
                          border: "1px solid black",
                          borderRadius: "100%",
                          background:
                            item.cases > 100 && item.result > 20
                              ? "#00CCCC"
                              : "#BE5504",
                          fontSize: "0.5rem",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          position: "absolute",
                          top: "-1.5rem",
                          left: "-1.5rem",
                        }}
                      >
                        {item.result > 100 && item.cases > 20 ? (
                          <>
                            <div
                              style={{ fontSize: "1rem", lineHeight: "0.8rem" }}
                            >
                              GRO
                            </div>
                            <div>RATED</div>
                          </>
                        ) : (
                          <>
                            <div
                              style={{ fontSize: "1rem", lineHeight: "0.8rem" }}
                            >
                              GRO
                            </div>
                            <div>VERIFIED</div>
                          </>
                        )}
                      </div>

                      <div style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
                        {item.title}
                      </div>

                      <div>{item.sub_title}</div>

                      <img
                        onClick={() => removeItem(item)}
                        src={item.image}
                        alt="procedure"
                        style={{
                          margin: "0.5rem 0",
                          cursor: "pointer",
                          width: "100%",
                          height: "10rem",
                          objectFit: "cover",
                        }}
                      />

                      <div
                        style={{
                          fontSize: "0.9rem",
                          opacity: "0.7",
                          padding: "0 1rem",
                        }}
                      >
                        {item.description}
                      </div>

                      <div
                        style={{
                          borderTop: "1px solid black",
                          borderBottom: "1px solid black",
                          padding: "0.5rem 0",
                          fontSize: "1.2rem",
                          fontWeight: "normal",
                          margin: "0.5rem 0",
                        }}
                      >
                        GRO score:{" "}
                        {item.gro_score === 0 ? "NA" : item.gro_score}
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "0.9rem",
                          marginBottom: "0.5rem",
                          height: "5rem",
                        }}
                      >
                        {item.result !== 0 && (
                          <div style={{ margin: "1rem" }}>
                            <div style={{ opacity: "0.7" }}>Results</div>
                            <div
                              style={{
                                background: "#B2FFFF",
                                width: "fit-content",
                                margin: "0 auto",
                                border: "1px solid black",
                                padding: "0.5rem",
                              }}
                            >
                              {item.result}
                            </div>
                          </div>
                        )}

                       
                          <div
                            style={{ margin: "1rem", cursor: "pointer" }}
                            onClick={() => cases(item)}
                          >
                            <div style={{ opacity: "0.7" }}>Cases</div>
                            <div
                              style={{
                                background: "#00CCCC",
                                width: "fit-content",
                                margin: "0 auto",
                                border: "1px solid black",
                                padding: "0.5rem",
                              }}
                            >
                              {item.cases}
                            </div>
                          </div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "0.9rem",
                        }}
                      >
                        <div style={{ textAlign: "center", width: "50%" }}>
                          <div style={{ textDecoration: "underline" }}>
                            Gender
                          </div>
                          <div>
                            <select
                              id="gender"
                              value={gender}
                              style={{
                                outline: "none",
                                border: "none",
                                padding: "0.1rem",
                                marginBottom: "0.3rem",
                                backgroundColor: "rgba(255, 255, 255, 0)",
                                width: `${12 * gender.length + 10}px`,
                              }}
                              onChange={(e) => setGender(e.target.value)}
                            >
                              <option value="All" selected>
                                All
                              </option>
                              <option value="Male">Male</option>
                              <option value="Female">Female</option>
                            </select>
                          </div>
                        </div>
                        <div style={{ textAlign: "center", width: "50%" }}>
                          <div style={{ textDecoration: "underline" }}>Age</div>
                          <select
                            id="age"
                            value={age}
                            style={{
                              outline: "none",
                              border: "none",
                              padding: "0.1rem",
                              marginBottom: "0.3rem",
                              backgroundColor: "rgba(255, 255, 255, 0)",
                              width: `${11 * age.length + 10}px`,
                            }}
                            onChange={(e) => setAge(e.target.value)}
                          >
                            <option value="All" selected>
                              All
                            </option>
                            <option value="under 20">under 20</option>
                            <option value="20-21">20-21</option>
                            <option value="31-40">31-40</option>
                            <option value="41-50">41-50</option>
                            <option value="51-60">51-60</option>
                            <option value="61-70">61-70</option>
                            <option value="over 70">over 70</option>
                          </select>
                        </div>
                      </div>

                      <IoIosAdd
                        onClick={() => openProcedure(item)}
                        style={{
                          fontSize: "40px",
                          cursor: "pointer",
                          color: "#E8E8E8",
                          position: "absolute",
                          bottom: "-2.5rem",
                          left: "0",
                          right: "0",
                          margin: "0 auto",
                        }}
                      />
                    </div>
                  </div>

                  {procedurePdf.isOpen && (
                    <div
                      style={{
                        position: "absolute",
                        right: "2.4rem",
                        top: "50%",
                        transform: "translateY(-50%)",
                        backgroundColor: "#E8E8E8",
                        height: "88.7%",
                        width: "40rem",
                        boxSizing: "border-box",
                        padding: "0 1rem",
                      }}
                    >
                      <img
                        src={procedurePdf.data.study_image}
                        alt="procedure"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                  )}

                  {procedureForm && (
                    <ProcedureForm
                      getTreatmentPlans={getTreatmentPlans}
                      item={item}
                      matchProcedure={matchProcedure}
                    />
                  )}

                  {openCases && <ShowCases item={item} />}
                </>
              );
            })}
        </Slider>
      </div>
    </>
  );
}

export default ProcedureTypes;
